import React from 'react';



type Props = {
  className?: string;
}
export const FavoriteFilledVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'currentColor' d = 'M20 7.99717V18.1914C20.0017 18.6644 19.8832 19.13 19.6556 19.5449C19.4281 19.9598 19.0988 20.3104 18.6985 20.564C18.2983 20.8175 17.8402 20.9657 17.3669 20.9947C16.8937 21.0238 16.4208 20.9327 15.9925 20.73L12.3657 19.0809C12.2351 19.0215 12.0934 18.9908 11.9499 18.9908C11.8064 18.9908 11.6646 19.0215 11.5341 19.0809L7.97745 20.73C7.61128 20.9034 7.21061 20.9922 6.80526 20.9898C6.06288 20.9846 5.35239 20.6881 4.82744 20.1644C4.30248 19.6407 4.00525 18.932 4 18.1914V7.99717C4 6.67184 4.52777 5.40079 5.46722 4.46364C6.40666 3.52649 7.68081 3 9.00939 3H15.0207C16.344 3.00792 17.6105 3.5379 18.5434 4.4742C19.4764 5.41049 20 6.67702 20 7.99717Z' />
    </svg>
  );
};
